/* ==========================================================================
   HEROI - so o selo que gira.
   O resto do heroi (foto, headline, busca) e desenhado pelo servidor em
   sections/heroi.liquid: e o que o Google le e o que aparece antes do JS.
   Cada troca espera a proxima imagem decodificar, para nunca aparecer um
   quadro vazio no meio da frase.
   ========================================================================== */
BV.quandoPronto(function () {
  const caixa = document.querySelector('.hx__foto');
  if (!caixa) return;
  const fotos = Array.from(caixa.querySelectorAll('img'));
  if (fotos.length < 2) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const PAUSA = 2400;
  let i = 0, parado = false;

  function proxima() {
    if (parado) return;
    const seguinte = (i + 1) % fotos.length;
    const img = fotos[seguinte];
    const troca = function () {
      fotos[i].classList.remove('ativa');
      img.classList.add('ativa');
      i = seguinte;
    };
    if (img.decode) img.decode().then(troca).catch(troca); else troca();
  }
  let relogio = setInterval(proxima, PAUSA);

  /* Fora da tela nao gasta bateria desenhando o que ninguem ve. */
  const obs = new IntersectionObserver(function (e) {
    parado = !e[0].isIntersecting;
  }, { threshold: 0 });
  obs.observe(caixa);
  document.addEventListener('visibilitychange', function () {
    clearInterval(relogio);
    if (!document.hidden) relogio = setInterval(proxima, PAUSA);
  });
});
